import { render } from "./request-item-batch.vue?vue&type=template&id=1c7d1bb8&scoped=true"
import script from "./request-item-batch.vue?vue&type=script&lang=js"
export * from "./request-item-batch.vue?vue&type=script&lang=js"

import "./request-item-batch.vue?vue&type=style&index=0&id=1c7d1bb8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7d1bb8"]])

export default __exports__